import { Component, computed, input, output } from '@angular/core';
import { COMMON_IMPORTS } from '../../../../../../Shared/common-imports';
import { LicenceComponentSummary } from '../../../../../../../Interfaces/api/licences.interface';
import { LICENCE_COMPONENT_LABEL_KEYS } from '../../../../../../../Consts/licences.const';

@Component({
    selector: 'app-licence-component-card',
    standalone: true,
    imports: [COMMON_IMPORTS],
    templateUrl: './licence-component-card.component.html',
    styleUrls: ['../../../billing/billing.scss'],
})
export class LicenceComponentCardComponent {
    readonly component = input.required<LicenceComponentSummary>();

    readonly buy = output<LicenceComponentSummary>();
    readonly cancel = output<LicenceComponentSummary>();

    readonly labelKey = computed<string>(() => LICENCE_COMPONENT_LABEL_KEYS[this.component().component_type]);

    readonly isCancellable = computed<boolean>(() => this.component().cancellable > 0);
}
